module.exports = __webpack_public_path__ + "static/media/21ECLAC22.0324d4ed.jpg";